import { render, staticRenderFns } from "./RequestPanel.vue?vue&type=template&id=8880f978&scoped=true&"
import script from "./RequestPanel.vue?vue&type=script&lang=js&"
export * from "./RequestPanel.vue?vue&type=script&lang=js&"
import style0 from "./RequestPanel.vue?vue&type=style&index=0&id=8880f978&lang=scss&scoped=true&"
import style1 from "./RequestPanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8880f978",
  null
  
)

export default component.exports